"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('weatherOption', {
    weatherEnabled: null,
    weatherUnit: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-weather-option/lib/store/store.js
// module id = 2943
// module chunks = 2